var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.status)?_c('span',{staticClass:"px-4 py-1 uppercase text-xs font-semibold text-white select-none ml-4",class:_vm.computeStatusStyle},[_vm._v(" "+_vm._s(_vm.status)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }